<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel modal__panel--policy-email-history">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
            </div>

            <div class="modal__main-icon modal__main-icon--email"></div>
            <div class="modal__close" @click="closeModal"></div>

            <div class="form">

                <transition name="fade" mode="out-in">
                    <Loading v-if="loading" />

                    <div v-else class="policy-email-history">
                        <div class="form__row">
                            <div class="form__field">
                                <h3 class="modal__title"> {{ $t(`emailHistoryModal.title`) }}</h3>
                            </div>
                        </div>
                        <div v-if="store.getters.policyEmailHistoryStatus === 'ineligible' || store.getters.policyEmailHistoryStatus === 'invalid_email'"
                            class="form__row form__row-ineligible">
                            <div class="form__field">
                                <p class="modal__title">{{ store.getters.policyEmailHistoryStatus === 'ineligible' ?
                                    $t(`emailHistoryModal.ineligible`) : $t(`emailHistoryModal.invalidEmail`) }}</p>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="!emailHistory.length" class="form__row">
                                <NoData :type="'policy-emails'" />
                            </div>

                            <div v-else class="policy-email-history__list">
                                <div v-for="item in emailHistory" :key="item.id || `${item.sent_at}-${item.subject}`"
                                    class="policy-email-history__item">
                                    <div class="policy-email-history__meta">
                                        <div class="policy-email-history__status-row">
                                            <span>{{ formatDate(item.sent_at || item.created_at) }}</span>
                                            <span>{{ item.state || item.status || 'sent' }}</span>
                                        </div>
                                    </div>
                                    <div class="policy-email-history__people">
                                        <span> {{ $t(`emailHistoryModal.sender`) }}: {{ item.sender_name || '—'
                                            }}</span>
                                    </div>
                                    <div class="policy-email-history__people">
                                        <span> {{ $t(`emailHistoryModal.recipient`) }}: {{ item.recipient_email || '—'
                                            }}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
import { formatDisplayDate } from "@/helpers/dateFormatters";

const store = useStore();
const loading = ref(false);
const emailHistory = ref([]);
const policyId = computed(() => store.getters.policyEmailHistoryPolicyId);

onMounted(async () => {
    if (store.getters.policyEmailHistoryStatus !== 'ineligible') {
        await fetchHistory();
    }
});

async function fetchHistory() {
    const resolvedPolicyId = Number(policyId.value);

    if (!resolvedPolicyId) {
        closeModal();
        return;
    }

    loading.value = true;

    try {
        const response = await store.dispatch("getPolicyEmailHistory", {
            policyId: resolvedPolicyId,
        });

        emailHistory.value = Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        emailHistory.value = [];
    } finally {
        loading.value = false;
    }
}

function formatDate(date) {
    if (!date) return "—";
    return formatDisplayDate(date);
}

function closeModal() {
    store.commit("setShowPolicyEmailHistoryModal", false);
    store.commit("setPolicyEmailHistoryStatus", null);
    store.commit("setPolicyEmailHistoryPolicyId", null);
    emailHistory.value = [];
}
</script>

<style scoped lang="scss">
.policy-email-history {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 80%;
    margin: 0 auto;
}

.policy-email-history__list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: auto;
}

.policy-email-history__item {
    background: var(--bg-16);
    border: 1px solid var(--bg-21);
    border-radius: 8px;
    padding: 12px 14px;
}

.policy-email-history__meta {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    font-size: 12px;
    color: var(--text-2);
    margin-bottom: 6px;
}

.policy-email-history__status-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 4px;
}

.policy-email-history__status-row {
    align-items: flex-end;
    text-align: right;
}

.policy-email-history__people {
    margin: 10px 0;
    font-size: 14px;
    color: var(--text-9);

    &:last-child {
        margin-bottom: 0;
    }
}

.form__field {
    width: 100%;
}

.modal__title {
    margin: 0;
    font-size: 20px;
    color: var(--text-9);
    text-align: center;
}

.modal .form {
    overflow: auto;
}

.empty {
    width: 100% !important;
    height: 100% !important;
    margin-top: 140px !important;
}

.form__row-ineligible {
    margin-top: 80px;
}
</style>